var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8119 4.60486H5.83229C5.02029 4.60486 4.36133 5.24832 4.36133 6.04067V23.0936C4.36133 23.8871 5.02029 24.5313 5.83229 24.5313H22.8119C23.6244 24.5313 24.2878 23.8871 24.2878 23.0936V6.04067C24.2878 5.24832 23.6244 4.60486 22.8119 4.60486ZM10.2712 21.585H7.31432V12.0759H10.2712V21.585ZM8.79276 10.7757C8.56769 10.7757 8.34483 10.7314 8.13692 10.6452C7.929 10.559 7.7401 10.4327 7.581 10.2736C7.42191 10.1144 7.29575 9.92537 7.20972 9.7174C7.12369 9.50942 7.07949 9.28654 7.07963 9.06147C7.07963 8.60716 7.26011 8.17146 7.58135 7.85021C7.9026 7.52896 8.33831 7.34849 8.79262 7.34849C9.24693 7.34849 9.68264 7.52896 10.0039 7.85021C10.3251 8.17146 10.5056 8.60716 10.5056 9.06147C10.5056 9.51587 10.3252 9.95169 10.004 10.2731C9.68283 10.5946 9.24716 10.7753 8.79276 10.7757ZM21.3404 21.585H18.3882V16.9609C18.3882 15.8578 18.3666 14.4394 16.8519 14.4394C15.3137 14.4394 15.0793 15.6408 15.0793 16.881V21.5853H12.1249V12.0759H14.9603V13.3744H15.0007C15.3953 12.6272 16.3596 11.8387 17.7976 11.8387C20.7882 11.8387 21.3406 13.8076 21.3406 16.369V21.585H21.3404Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdin);
export default __webpack_public_path__ + "static/media/linkdin.6166b6e0a54c4d3a2996c1343aafb0c9.svg";
export { ForwardRef as ReactComponent };